import {
  FORM_FIELDS,
  FormValues,
} from "../../../infrastructure/components/types";
import Repository from "../../repository/repository";
import { HEADER_TYPES } from "../../repository/types";
import { PostFormProps } from "./types";

export default class FormService {
  private repository = new Repository();

  async PostForm(postFormProps: FormValues): Promise<any> {
    const formData: PostFormProps = {
      userName: postFormProps[FORM_FIELDS.NAME],
      userLastName: postFormProps[FORM_FIELDS.LASTNAME],
      userIdentification: "123456789",
      userEmail: postFormProps[FORM_FIELDS.EMAIL],
      phone: postFormProps[FORM_FIELDS.PHONE],
      department: postFormProps[FORM_FIELDS.MOTIVE],
      description: postFormProps[FORM_FIELDS.DESCRIPTION],
      companyId: "6189517e5ce45d54c137d702",
      title: "Consulta",
      source: "web",
    };

    const encodedFormData = Object.keys(formData)
      .map(
        (key) =>
          encodeURIComponent(key) + "=" + encodeURIComponent(formData[key])
      )
      .join("&");

    const response = await this.repository.post(
      `/webForm`,
      encodedFormData,
      HEADER_TYPES.FORM_URLENCODED
    );

    return response;
  }
}
